export const stageType =  [
    
    {
      name: "开店加盟",
      value: 'openShop',
    },
    {
      name: "改造",
      value: 'reform',
    },
    {
      name: "商场联营",
      value: 'mallMec',
    },
    {
      name: "设备投资",
      value: 'deviceInvest',
    },
    
  ]